import React from 'react';

export const PrintContext = React.createContext({
  wrapper: null as HTMLDivElement | null,
});

export const usePrintContext = () => React.useContext(PrintContext);
